module.exports = __webpack_public_path__ + "static/img/200050.a10462a0.png";